import { ValidationType } from '../utils/validators';

import Field, { FieldDataType } from './Field';
import { Section } from './index';
import { SMOKING_POLICY } from '../constants';

export default class SmokingPolicySection extends Section {
  constructor(args) {
    super(args);

    this.setIndexedFieldTypes([
      new Field({
        fieldName: SMOKING_POLICY.FIELD_NAME.CUSTOM_AREA_IS_ENABLED,
        dataType: FieldDataType.boolean,
        enteredValue: true,
        validation: ValidationType.BooleanValidator,
      }),
      new Field({
        fieldName: SMOKING_POLICY.FIELD_NAME.CUSTOM_AREA_DESCRIPTION,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
    ]);
  }
}
